import { createSelector } from 'reselect';

// Config
import { GUERNSEY_POSTCODE_PREFIX } from '@constants/postcodeConstants';
import { getSelectedCollectionPointPostcodeSelector } from '@redux/reducers/click-and-collect/clickAndCollectSelector';
import {
  getConfirmedDeliveryAddressPostcodeSelector,
  getSelectedDeliveryChoiceIdSelector,
} from '@redux/reducers/delivery/deliverySelector';
import { isClickAndCollectChoice, isDeliveryChoice } from '@utils/delivery/deliveryHelper';

const guernseyMessageState = createSelector(
  [
    getSelectedDeliveryChoiceIdSelector,
    getConfirmedDeliveryAddressPostcodeSelector,
    getSelectedCollectionPointPostcodeSelector,
  ],
  (selectedDeliveryChoiceId, deliveryPostcode = '', clickAndCollectPostcode = '') => {
    const isDelivery = isDeliveryChoice(selectedDeliveryChoiceId);
    const isClickAndCollect = isClickAndCollectChoice(selectedDeliveryChoiceId);

    let postcode = '';
    if (isDelivery) {
      postcode = deliveryPostcode;
    } else if (isClickAndCollect) {
      postcode = clickAndCollectPostcode;
    }

    if (postcode) {
      return postcode.startsWith(GUERNSEY_POSTCODE_PREFIX);
    }

    return false;
  },
);

export default guernseyMessageState;
